import { render, staticRenderFns } from "./AccountDashboardOrganisation.vue?vue&type=template&id=46aafbda&"
import script from "./AccountDashboardOrganisation.vue?vue&type=script&lang=ts&"
export * from "./AccountDashboardOrganisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46aafbda')) {
      api.createRecord('46aafbda', component.options)
    } else {
      api.reload('46aafbda', component.options)
    }
    module.hot.accept("./AccountDashboardOrganisation.vue?vue&type=template&id=46aafbda&", function () {
      api.rerender('46aafbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountDashboard/AccountDashboardOrganisation.vue"
export default component.exports